let searchValid = function(val){
	console.log('searchValid', val)	
	if(!val) {
		this.dateFrom = '';
		this.dateTo = '';
		this.searchText = '';
	}
};
export default searchValid;
